import { Component, Inject, Input, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common'; 

@Component({
  selector: 'app-cronometro',
  templateUrl: './cronometro.component.html',
  styleUrls: ['./cronometro.component.css']
})
export class CronometroComponent implements OnInit {
  
  public minutos: number = 4;
  public minutosstring = "5";
  public segundos: number = 60;
  public color: string = "#0FD332";
  public interval;

  constructor(@Inject(DOCUMENT) document) { }

  ngOnInit() {
   
     this.minutos = 4;
     this.minutosstring = "4";
   

    
    
  }


  iniciacronometro() {
    this.start();
  }


  limpiasegundos(){
    for (let i = 1; i < 60; i++) {
      var svg_css = document.getElementById("seg" + i );
        svg_css.style.fill= "#ffffff" ;
    }

    this.minutos = 4;
    this.minutosstring= "4";
    document.getElementById("textminutos").innerHTML = "4";
  }


  altocronometro(){
    clearInterval(this.interval);
  }


  start(){
    this.limpiasegundos();
    this.segundos = 60;
     
  }
  

}
